<script>
    export let continent;
</script>

{#if continent}
<div class="c-map__cont" 
     style="top: {continent.top}%; left: {continent.left}%; width: {continent.width}%; height: {continent.height}%;"></div>
{/if}